import React, { FC, ReactNode } from "react"

import Scrubber, { SCRUBBER_THRESHOLDS } from "@components/Scrubber/Scrubber"

const RevealArea: FC<{ children: ReactNode }> = ({ children }) => (
  <Scrubber threshold={SCRUBBER_THRESHOLDS.BOTTOM_BOTTOM}>
    {(ref, pctCompleted) => (
      <div
        className="RevealArea"
        ref={ref}
        style={{
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          className="RevealArea--shadow"
          style={{
            boxShadow: "var(--elevation--M)",
            height: 0,
            left: "-10vw",
            position: "absolute",
            top: 0,
            width: "120vw",
            zIndex: 1,
          }}
        />
        <div
          className="RevealArea--wrapper"
          style={{
            transform: `translateY(${(1 - pctCompleted) * -10}vw)`,
          }}>
          {children}
        </div>
      </div>
    )}
  </Scrubber>
)

export default RevealArea
